import Notifications from '@/pages/Notifications';
import * as React from 'react';
import { createRoot } from 'react-dom/client';

WiseMetering.Views.IndexNotifications = Backbone.Marionette.View.extend({
    id: 'notifications-container',

    onShow: function() {
        WiseMetering.notifications.fetch();
        const container = document.getElementById(this.id);
        const root = createRoot(container);
        root.render(<Notifications notifications={WiseMetering.notifications}/>);
    }
});
